export enum UploaderPageTypes {
  DEFAULT = 'default',
  MAKER = 'maker',
  BLOG = 'blog',
}

export interface UploaderFormOptions {
  pageType?: UploaderPageTypes;
  mainHeaderText?: string;
  headerTitle?: string;
  buttonText?: string;
  uploadTitle?: string;
}

export const UploaderFormOptions: Record<UploaderPageTypes, UploaderFormOptions> = {
  [UploaderPageTypes.DEFAULT]: {
    pageType: UploaderPageTypes.DEFAULT,
    mainHeaderText: 'Upload File',
    headerTitle: 'File Uploader',
    buttonText: 'Add file',
    uploadTitle: 'Drop files here',
  },
  [UploaderPageTypes.MAKER]: {
    pageType: UploaderPageTypes.MAKER,
    mainHeaderText: 'Sign a Document Right Now.',
    headerTitle: 'Try out your new digital signature on any file.',
    buttonText: 'Select file',
    uploadTitle: 'Drop files here',
  },
  [UploaderPageTypes.BLOG]: {
    pageType: UploaderPageTypes.BLOG,
    mainHeaderText: 'Need a signature fast?',
    headerTitle: 'Upload any PDF or Word doc to get started.',
    buttonText: 'Sign a File Now',
    uploadTitle: 'Drop files here',
  },
};
